<div class="import-modal">
  <header class="import-modal-header">
    <h1 class="sm-text-xl sm-font-medium">Upload a CSV file from your computer</h1>
    <div (click)="modal.close()" class="sm-ml-auto hover:sm-cursor-pointer">
      <i class="cc-icon cc-icon-close sm-align-middle"></i>
    </div>
  </header>
  <div class="import-modal-body">
    <p>
      Select the CSV file you wish to upload into the list. Property values that match the accepted property
      types will be uploaded into the Dashpivot List.
    </p>

    <p>
      Note: Attachments cannot be uploaded via CSV, please add the attachments to the list after uploading.
    </p>
    <div>
      <a
        href="https://intercom.help/dashpivot/en/articles/5229601-list-importing"
        target="_blank"
        class="btn learn-more-button cc-btn-subtle-dark-gray"
        rel="noopener"
      >
        <div class="sm-flex sm-items-center sm-gap-1">
          <i class="cc-icon cc-icon-question"></i
          ><span class="sm-font-medium">Learn how to set up your CSV</span>
        </div>
      </a>
    </div>

    <cc-file-upload-dropzone
      [uploadTrigger]="uploadTrigger"
      [maxFiles]="1"
      [acceptedFiles]="'.csv'"
      [maxFilesErrorMessage]="'Unable to import more than one CSV file at a time.'"
      (error)="handleDropzoneError($event)"
      (addedfile)="enableImport($event)"
    ></cc-file-upload-dropzone>

    <div *ngIf="validating" class="sm-text-secondary-text sm-flex sm-items-center sm-gap-1">
      <div class="cc-icon cc-icon-spinner-sm"></div>
      Validating your CSV file...
    </div>

    <div class="warning-container" *ngIf="listErrorsByColumnMap.size > 0">
      <i class="cc-icon cc-icon-warning sm-flex sm-items-center"></i>
      <span>Invalid formatting detected in CSV file.</span>
      <button type="button" (click)="downloadErrors()">
        <a class="sm-underline">Click here to view errors.</a>
      </button>
    </div>

    <div class="error-container" *ngIf="blockingError">
      <i class="cc-icon cc-icon-warning sm-flex sm-items-center"></i>
      <span>Unable to import CSV. {{ blockingError }}</span>
    </div>

    <div class="import-modal-details">
      <span>Accepted file types: CSV only</span>
      <span>Accepted Property types: Text, Number, Date and Date Expiry (DD/MM/YYYY)</span>
      <span>Individual file size limit: 10MB</span>
      <span>List item row limit: {{ maxListRows }} item rows per file</span>
    </div>
  </div>
  <div class="import-modal-footer">
    <button
      #uploadTrigger
      type="button"
      class="btn cc-btn-subtle-blue sm-px-2"
      [disabled]="!canImport || validating"
      data-test="import-button"
      (click)="sendFileToServer()"
    >
      <span>Upload</span>
    </button>
  </div>
</div>
